"use strict";

import axios from "axios";

let config = {};

// Criando uma instância do Axios
const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Criando o plug-in para Vue 3
const axiosPlugin = {
  install(app) {
    // Adiciona Axios às propriedades globais
    app.config.globalProperties.$axios = _axios;
    // Opcional: disponibiliza Axios globalmente
    window.axios = _axios;
  }
};

export default axiosPlugin;
